<section class="convocations-table !mt-10" aria-labelledby="convocations-table-heading">
    <ui-table
        #convocationsTable
        table-title="Tutte le convocazioni"
        table-description="Elenco completo delle convocazioni future e passate."
    >
        <ng-template #customHeader>
            <tr>
                <th>Titolo</th>
                <th>Categoria</th>
                <th>Data</th>
                <th>Luogo</th>
                <th>Stato</th>
                <th>Convocati</th>
                <th class="text-end pe-3">Azioni</th>
            </tr>
        </ng-template>

        <ng-template #customRow let-row="row">
            <tr>
                <td class="convocation-cell--title fw-bold text-dark">{{ row.title }}</td>
                <td data-label="Categoria">{{ row.categoryName || '—' }}</td>
                <td data-label="Data">
                    <div>
                        <span class="d-block fw-semibold">{{ row.date | date : 'EEEE d MMMM y' : '' : 'it' }}</span>
                        <span class="d-block small text-muted">ore {{ row.date | date : 'HH:mm' : '' : 'it' }}</span>
                    </div>
                </td>
                <td data-label="Luogo">
                    <div>
                    <span class="d-block fw-semibold">{{ row.location }}</span>
                    <span class="d-block small text-muted">
                        {{ row.city }}<ng-container *ngIf="row.province"> ({{ row.province }})</ng-container>
                    </span>
                    </div>
                </td>
                <td data-label="Stato">
                    <span class="badge" [ngClass]="statusBadgeClass(row.status)">
                        {{ row.status }}
                    </span>
                </td>
                <td data-label="Convocati">
                    <ng-container *ngIf="invitedCount(row) as count; else noInvited">
                        {{ count }}
                    </ng-container>
                    <ng-template #noInvited>—</ng-template>
                </td>
                <td class="convocation-cell--actions text-end pe-3">
                    <div class="d-inline-flex align-items-center gap-1">
                        <ng-container *ngIf="showDraftActions && isDraft(row.status)">
                            <button
                                type="button"
                                class="btn btn-sm convocation-draft-btn convocation-draft-btn--approve"
                                [disabled]="isUpdating(row.id)"
                                (click)="approveDraft.emit(row)"
                                aria-label="Approva e pubblica convocazione"
                                title="Approva e pubblica"
                            >
                                <i class="bi bi-check-lg" aria-hidden="true"></i>
                            </button>
                            <button
                                type="button"
                                class="btn btn-sm convocation-draft-btn convocation-draft-btn--cancel"
                                [disabled]="isUpdating(row.id)"
                                (click)="cancelDraft.emit(row)"
                                aria-label="Annulla convocazione"
                                title="Annulla"
                            >
                                <i class="bi bi-x-lg" aria-hidden="true"></i>
                            </button>
                        </ng-container>
                        <a
                            class="btn welldone-btn-gray btn-sm"
                            [routerLink]="detailRoute(row.id)"
                            title="Dettaglio convocazione"
                            aria-label="Apri il dettaglio della convocazione"
                        >
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                             class="bi bi-eye-fill" viewBox="0 0 16 16">
                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>
                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"/>
                        </svg>
                        <span class="convocation-detail-label">Dettaglio</span>
                    </a>
                    </div>
                </td>
            </tr>
        </ng-template>
    </ui-table>
</section>
